import Component from './setting_user_two_factor_dialog.vue'
export default Component
